import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-950 text-background-50">
      {/* Main Footer */}
      <div className="w-full px-6 md:px-10 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
            {/* Column 1: Logo + Description */}
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 cursor-pointer mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                  <i className="ri-sailboat-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-semibold">
                  Kakobuy Yachts
                </span>
              </Link>
              <p className="text-sm text-background-50/60 leading-relaxed max-w-xs">
                {t("footer.description")}
              </p>
            </div>

            {/* Column 2: Newsletter */}
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-background-50/40 mb-4">
                {t("footer.newsletter")}
              </h4>
              <form
                data-readdy-form="true"
                id="newsletter-footer"
                action="https://readdy.ai/api/form/d8ro7sde8ise6dlc8ltg"
                method="POST"
                encType="application/x-www-form-urlencoded"
                className="relative mb-3"
              >
                <input
                  type="email"
                  name="email"
                  placeholder={t("footer.newsletterPlaceholder")}
                  className="w-full bg-transparent border-b border-background-50/20 py-2 pr-10 text-sm text-background-50 placeholder:text-background-50/30 focus:outline-none focus:border-accent-400 transition-colors"
                />
                <button
                  type="submit"
                  className="absolute right-0 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                  aria-label="Subscribe"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </form>
              <p className="text-xs text-background-50/30">
                {t("footer.newsletterHint")}
              </p>
            </div>

            {/* Column 3: Categories */}
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-background-50/40 mb-4">
                {t("footer.categories")}
              </h4>
              <div className="grid grid-cols-2 gap-x-4 gap-y-1.5">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/55 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Column 4: Social */}
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-background-50/40 mb-4">
                {t("footer.social")}
              </h4>
              <div className="flex flex-col gap-2">
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/55 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  Kaspreadsheet
                </a>
                <Link
                  to="/"
                  className="text-sm text-background-50/55 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  Strona główna
                </Link>
                <Link
                  to="/artykul/jak-korzystac-z-kakobuy-spreadsheet"
                  className="text-sm text-background-50/55 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  Przewodnik
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Large KAKOBUY text */}
      <div className="w-full overflow-hidden border-t border-background-50/5">
        <div className="py-8 px-6">
          <div className="font-heading text-[6rem] md:text-[10rem] lg:text-[14rem] font-black text-background-50/[0.03] leading-none tracking-tighter text-center select-none">
            KAKOBUY
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-background-50/5">
        <div className="px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 max-w-7xl mx-auto">
          <span className="text-xs text-background-50/30">
            {t("footer.copyright")}
          </span>
          <div className="flex items-center gap-6">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/30 hover:text-background-50/50 transition-colors cursor-pointer"
            >
              kakobuy spreadsheet
            </a>
            <Link
              to="/"
              className="text-xs text-background-50/30 hover:text-background-50/50 transition-colors cursor-pointer"
            >
              Strona główna
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}